<template>
  <div class="integral-record">
    <div class="incont">积分试运行期间，规则不时会有适当调整，带来不便敬请谅解</div>
    <div class="personal" v-if="show==1?true:false">
      <p
        style="padding-bottom: .7rem"
      >个人积分是“洪雅智慧党建云平台”对用户通过本平台进行使用的行为分析数据，严禁利用刷分软件等谋取利益。一旦发现，将会同网信管理部门、公安机关依法进行严厉打击。用户一旦被技术手段监测到有使用刷分软件的行为，将被封禁。</p>
      <b>本平台将对以下使用学习行为进行积分，规则如下:</b>
      <div class="title-tem">
        <b>登陆</b>
        <p>每日登录平台积1积分。（每日上限1分）</p>
      </div>
      <div class="title-tem">
        <b>阅读文章</b>
        <p>阅读“洪雅新闻”等图文板块文章，每篇积1积分。（每日上限5分）</p>
      </div>
      <div class="title-tem">
        <b>学习课件</b>
        <p>观看党群教育中课件，每个课件积1分。（每日上限5分）</p>
      </div>
      <div class="title-tem">
        <b>收藏</b>
        <p>每收藏一个/条精品课件、本土课件、洪雅新闻等，积1分。（每日上限3分）</p>
      </div>
    </div>
    <!-- 党员说明 -->
    <div class="party" v-if="show==2?true:false">
      <p
        style="padding-bottom: .7rem"
      >党组织积分是“洪雅智慧党建云平台”内各个党支部的活动行为分析数据，仅本平台注册党员可见，且只有支部管理员才能进行上传活动。严禁利用刷分软件谋取利益。一旦发现，将会同网信管理部门、公安机关依法进行严厉打击。</p>
      <b>本平台将对以下使用学习行为进行积分，规则如下:</b>
      <!-- <div class="title-tem">
        <b>支部空间上传动态</b>
        <p>党支部在支部空间每上传1条动态积1分。（无上限）</p>
      </div> -->
      <div class="title-tem">
        <b>上传“三会一课”</b>
        <p>党支部每上传1条“三会一课”积1分。（无上限）</p>
      </div>
      <!-- <div class="title-tem">
        <b>发起直播</b>
        <p>在支部开展活动期间发起直播，每直播一次积5分。（无上限）</p>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: 0
    };
  },
  created: function() {

    if (this.$route.query.title == "个人积分说明") {
      this.show = 1;
    } else this.show = 2;
  }
};
</script>
<style lang='scss' scoped>
.integral-record {
  .incont {
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    font-size: 0.26rem;
    background: rgba($color: #fa8c36, $alpha: 0.1);
    padding-left: 0.2rem;
  }
  .party,
  .personal {
    font-size: 0.3rem;
    line-height: 0.5rem;
    width: 94%;
    margin: 0 auto;
    margin-top: 0.48rem;
  }

  .title-tem {
    margin-top: 0.54rem;
  }

  .title-tem b {
    border-left: 0.1rem solid #fabe59;
    padding-left: 0.2rem;
  }

  .title-tem p {
    padding-top: 0.2rem;
  }
  padding: 1rem 0;
  font-size: 0.3rem;
}
</style>